/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Edit_Confirm_TitleInputs */

const es_chat_edit_confirm_title = /** @type {(inputs: Chat_Edit_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Editar mensaje?`)
};

const en_chat_edit_confirm_title = /** @type {(inputs: Chat_Edit_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit message?`)
};

/**
* | output |
* | --- |
* | "Edit message?" |
*
* @param {Chat_Edit_Confirm_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_edit_confirm_title = /** @type {((inputs?: Chat_Edit_Confirm_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Edit_Confirm_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_edit_confirm_title(inputs)
	return en_chat_edit_confirm_title(inputs)
});
export { chat_edit_confirm_title as "chat.edit.confirm_title" }